import type { ReactNode } from "react";
import { cn } from "@carry/ui";
import type { Tab } from "../lib/normalize";

export function Header({
  title,
  sub,
  tabs,
  active,
  onTab,
  showBack,
  onBack,
  action,
}: {
  title: string;
  sub: string;
  tabs?: Tab[];
  /** 選択中のタブ。どのタブにも属さない日 (過去日) を見ているときは undefined。 */
  active?: Tab;
  onTab?: (t: Tab) => void;
  showBack?: boolean;
  onBack?: () => void;
  /** タイトル行の右端に表示するアクション (設定歯車など) */
  action?: ReactNode;
}) {
  return (
    <div className="bg-[var(--bg-panel)] shadow-[0_0.5px_0_var(--rule-soft)]">
      <div className="flex items-center gap-2.5 px-4 pb-2 pt-3.5">
        {showBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="戻る"
            className="inline-flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center border-0 bg-transparent text-[length:var(--fs-2xl)] leading-none text-[var(--ink-2)]"
          >
            ‹
          </button>
        )}
        <div className="min-w-0 flex-1">
          <div className="break-words text-[length:var(--fs-md)] font-semibold">{title}</div>
          <div className="mt-px text-[length:var(--fs-xs)] text-[var(--ink-3)]">{sub}</div>
        </div>
        {action}
      </div>
      {/* #768: 過去日はどのタブにも属さない。active 無しでもタブは「今日」へ戻る導線として残す。 */}
      {tabs && onTab && (
        <div className="flex border-b border-[var(--rule-soft)]">
          {tabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => onTab(t)}
              className={cn(
                "flex-1 cursor-pointer border-0 bg-transparent py-2.5 text-[length:var(--fs-sm)] font-medium",
                t === active
                  ? "border-b-2 border-[var(--status-delivery)] text-[var(--ink)]"
                  : "border-b-2 border-transparent text-[var(--ink-3)]",
              )}
            >
              {t}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
